import React from 'react';

interface ReturnedIconProps {
  className?: string;
  size?: number;
}

/**
 * Ícono de "Devoluciones"
 * 
 * DESCRIPCIÓN VISUAL:
 * - Una caja/paquete con flechas de retorno
 * - Forma de caja rectangular con flechas curvas que indican movimiento de regreso
 * - Flechas apuntan hacia atrás o en dirección opuesta
 * - Representa devoluciones, reembolsos o productos que regresan
 * - Estilo minimalista, líneas limpias
 * - Simboliza el proceso inverso de envío o venta
 * 
 * Usa currentColor para adaptarse automáticamente al tema light/dark
 */
export const ReturnedIcon: React.FC<ReturnedIconProps> = ({
  className = '',
  size = 150,
}) => {
  return (
    <svg
      width={size}
      height={(size * 150) / 146}
      viewBox="0 0 146 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M108.959 0C115.658 0 121.938 3.23276 125.821 8.66379L141.648 30.8082C144.141 34.2996 145.5 38.5345 145.5 42.8341V129.31C145.5 140.722 136.211 150 124.786 150H21.2143C9.78906 150 0.5 140.722 0.5 129.31V42.8341C0.5 38.5345 1.85938 34.3319 4.35156 30.8082L20.1786 8.66379C24.0949 3.23276 30.3739 0 37.0413 0H108.926H108.959ZM5.67857 42.8341V129.31C5.67857 137.877 12.6373 144.828 21.2143 144.828H124.786C133.363 144.828 140.321 137.877 140.321 129.31V42.8341C140.321 42.3491 140.289 41.8642 140.257 41.3793H5.7433C5.71094 41.8642 5.67857 42.3491 5.67857 42.8341ZM100.058 62.4892C101.061 61.8103 102.421 61.9397 103.327 62.8125L121.452 80.9159L121.776 81.3362C122.455 82.3384 122.326 83.6961 121.452 84.6013C120.578 85.5065 119.186 85.6035 118.183 84.9246L117.762 84.6013L104.071 70.9267V121.584C104.071 123.006 102.906 124.17 101.482 124.17C100.058 124.17 98.8929 123.006 98.8929 121.584V70.9267L85.202 84.6013C84.1987 85.6035 82.548 85.6035 81.5446 84.6013C80.5413 83.5991 80.5413 81.9504 81.5446 80.9483L99.6696 62.8448L100.09 62.5215L100.058 62.4892ZM44.5179 62.069C45.942 62.069 47.1071 63.2328 47.1071 64.6552V115.313L60.798 101.638L61.1864 101.315C62.1897 100.636 63.5491 100.765 64.4554 101.638C65.3616 102.511 65.4587 103.901 64.779 104.903L64.4554 105.323L46.3304 123.427C45.4565 124.3 44.0647 124.429 43.0614 123.75L42.673 123.427L24.548 105.323C23.5446 104.321 23.5446 102.672 24.548 101.67C25.5513 100.668 27.202 100.668 28.2054 101.67L41.9286 115.313V64.6552C41.9286 63.2328 43.0938 62.069 44.5179 62.069ZM37.0413 5.17241C32.0245 5.17241 27.2991 7.59698 24.3862 11.6703L8.55915 33.8147C8.00893 34.5582 7.5558 35.3664 7.16741 36.2069H70.4107V5.17241H37.0413ZM75.5893 36.2069H138.833C138.444 35.3664 137.959 34.5905 137.441 33.8147L121.581 11.6703C118.669 7.59698 113.943 5.17241 108.926 5.17241H75.5569V36.2069H75.5893Z"
        fill="currentColor"
      />
    </svg>
  );
};

